import { Shell, StepFooter } from "@/components/Shell";
import { OptionList } from "@/components/OptionList";
import { EMOTIONAL_QUESTIONS, YES_NO_UNKNOWN } from "@/lib/questions";

export function EmotionalStep({ answers, setAnswer, onBack, onNext, progress, onSelfHarm }) {
  const handleChange = (id, v) => {
    setAnswer(id, v);
    if (id === "hacerse_dano" && v === "yes") {
      // Detener el flujo y mostrar ayuda inmediata
      setTimeout(() => onSelfHarm(), 100);
    }
  };

  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Bienestar emocional</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        Cómo te has sentido últimamente
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Estas preguntas son delicadas. Responde sólo lo que quieras compartir; nadie
        más lo verá.
      </p>

      <div className="mt-6 space-y-6">
        {EMOTIONAL_QUESTIONS.map((q) => (
          <div key={q.id} className="cc-card p-5">
            <p className="font-medium mb-3">{q.text}</p>
            <OptionList
              name={q.text}
              options={YES_NO_UNKNOWN}
              value={answers[q.id]}
              onChange={(v) => handleChange(q.id, v)}
              testIdPrefix={q.id}
            />
          </div>
        ))}
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="emotional-back-btn">
          Atrás
        </button>
        <button onClick={onNext} className="cc-btn-primary" data-testid="emotional-next-btn">
          Continuar
        </button>
      </StepFooter>
    </Shell>
  );
}
